import actions from './actions'

const defaultState = {
  report: { reportLength: 0, pagedReport: [] },
  reportOptions: { activePage: 1, pageLength: 50 },
  loading: false,
  reportTypes: [],
  reportTypesLoading: false,
  selectedReportType: ''
}

const reports = (state = defaultState, action) => {
  switch (action.type) {
    case actions.setReport:
      return { ...state, report: action.report, loading: false }
    case actions.fetchPending:
      return { ...state, loading: true }
    case actions.setReportOptions:
      return { ...state, reportOptions: action.reportOptions }
    case actions.setReportTypes:
      return { ...state, reportTypes: action.reportTypes, reportTypesLoading: false }
    case actions.failedReportTypes:
      return { ...state, error: action.error, reportTypesLoading: false }
    case actions.reportTypesFetchPending:
      return { ...state, reportTypesLoading: true }
    case actions.setSelectedReportType:
      return { ...state, selectedReportType: action.selectedReportType }
    default:
      return state
  }
}

export default reports



// WEBPACK FOOTER //
// ./src/store/reports/reducer.js